import { createRoute } from "@tanstack/react-router";
import { hubLayoutRoute } from "../portal/PortalLayout";

export const accountRoute = createRoute({
  getParentRoute: () => hubLayoutRoute,
  path: "account",
}).lazy(() => import("./Account.lazy").then((d) => d.Route));
